export const ES = {
  "Open document": "Abrir documento",
  "Upload file": "Subir archivo",
  "Drop file here to upload": "Suelta el archivo aquÃ­ para subirlo",
  "Disc": "Desct",
  "URL": "URL",
  "FILE": "EXPEDIENTE",
  "SIZE": "TALLA",
  "MB": "MEGABYTE",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "Cargando por favor espere.",
  "Fit Width": "Ajuste ancho",
  "Fit Height": "Altura de ajuste",
  "Password protected document": "Documento protegido con contraseÃ±a",
  "Password": "ContraseÃ±a",
  "Open": "Abierto",
  "Password Required": "Se requiere contraseÃ±a",
  "Incorrect password": "ContraseÃ±a incorrecta",
  "Error": "Error",
  "Something went wrong": "Algo saliÃ³ mal",
  "Server is not available": "El servidor no esta disponible",
  "of": "de",
  "Please wait...": "Espere por favor..."
};
